import { useChangePasswordForm } from '@/forms/change-password.form';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Stack,
  TextField,
} from '@mui/material';
import { DialogProps } from '@components/dialogs/dialogs-provider';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

export function ChangePasswordDialog({
  open,
  onClose,
}: DialogProps<undefined, string | null>) {
  const { t } = useTranslation('common');
  const { enqueueSnackbar } = useSnackbar();
  const {
    register,
    onSubmit,
    setValue,
    setError,
    formState: { errors: formErrors },
  } = useChangePasswordForm({
    onSuccess: (data) => {
      enqueueSnackbar(t('dialogs.changePassword.success'), {
        variant: 'success',
      });
      onClose(null);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response?.status === 400) {
          setError('currentPassword', {
            message: error.response?.data.message,
          });
        }
      }
    },
  });

  return (
    <Dialog
      component="form"
      onSubmit={onSubmit}
      fullWidth
      open={open}
      onClose={() => onClose(null)}
    >
      <DialogTitle>{t('dialogs.changePassword.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText gutterBottom>
          {t('dialogs.changePassword.description')}
        </DialogContentText>
        <br />
        <Stack spacing={2} sx={{ py: 1 }}>
          <TextField
            label={t('dialogs.changePassword.fields.currentPassword')}
            type="password"
            fullWidth
            {...register('currentPassword')}
            error={!!formErrors.currentPassword}
            helperText={formErrors.currentPassword?.message}
          />
          <Divider />
          <TextField
            label={t('dialogs.changePassword.fields.newPassword')}
            type="password"
            fullWidth
            {...register('newPassword')}
            error={!!formErrors.newPassword}
            helperText={formErrors.newPassword?.message}
          />
          <TextField
            label={t('dialogs.changePassword.fields.confirmPassword')}
            type="password"
            fullWidth
            {...register('confirmNewPassword')}
            error={!!formErrors.confirmNewPassword}
            helperText={formErrors.confirmNewPassword?.message}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(null)}>{t('actions.cancel')}</Button>
        <Button type={'submit'}>{t('actions.save')}</Button>
      </DialogActions>
    </Dialog>
  );
}
